"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable:max-classes-per-file

var React = require("react");

exports.createGenericContext = function (readValue, writeValue) {
  var readContext = React.createContext(readValue);
  var writeContext = React.createContext(writeValue); // tslint:disable-next-line:no-object-literal-type-assertion

  var bothContext = React.createContext(__assign({}, readValue, writeValue));
  var Consumers = {
    Both: bothContext.Consumer,
    Read: readContext.Consumer,
    Write: writeContext.Consumer
  };
  var Providers = {
    Both: bothContext.Provider,
    Read: readContext.Provider,
    Write: writeContext.Provider
  };

  var allConsumers = __spread(Object.values(Consumers));

  var allProviders = __spread(Object.values(Providers));

  return {
    Consumers: Consumers,
    Providers: Providers,
    allConsumers: allConsumers,
    allProviders: allProviders,
    allProvidersJSX: function allProvidersJSX(state, children) {
      // tslint:disable-next-line
      return allProviders.reduce(function (prev, Curr) {
        return React.createElement(Curr, {
          value: state
        }, prev);
      }, children);
    }
  };
};